import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CartState {
  isCartVisible: boolean;
}

const initialState: CartState = {
  isCartVisible: false,
};

const cartSlice = createSlice({
  name: 'CartState',
  initialState,
  reducers: {
    setCartVisibility: (state, action: PayloadAction<boolean>) => {
      state.isCartVisible = action.payload;
    },
    toggleCartVisibility: (state) => {
      state.isCartVisible = !state.isCartVisible;
    },
  },
});

export const { setCartVisibility, toggleCartVisibility } = cartSlice.actions;
export default cartSlice.reducer;